// extracted by mini-css-extract-plugin
export var layoutContainer = "_44-0";
export var layoutContainerOpen = "_44-5";
export var layoutContainerResizing = "_44-1";
export var mainContent = "_44-2";
export var resizeDivider = "_44-3";
export var slidePanel = "_44-4";